module.exports = __webpack_public_path__ + "static/media/whatsapp.2e4ba20f.png";